import App from './App'

import { createSSRApp } from 'vue'
import * as Pinia from 'pinia';
import piniaPluginPersist from 'pinia-plugin-persist-uni'
import collegeItem from "@/components/college-item/college-item.vue"
import waterfallItem from "@/components/waterfall-item/waterfall-item.vue"

const store = Pinia.createPinia();
store.use(piniaPluginPersist)
export function createApp() {
  const app = createSSRApp(App)
  app.use(store);
  app.use(collegeItem)
  app.use(waterfallItem)
  return {
    app,
    Pinia, // 此处必须将 Pinia 返回
  }
}
// 解决uni.$emit重复触发
let onFun = uni.$on;
uni.$on = (eventName,obj) =>{
try {
uni.$off(eventName);
} catch (error) {}
onFun(eventName,obj);
}